<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      line-form
      show-save-button
      unit="结算方式"
      edit-title
      form-label-width="110px"
      id-key="SettleId"
      :data="data"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="结算方式编码" prop="SettleNo" :class="isMB?'longLabel':''">
          <span v-if="Mode==0" class="detail-span">{{data.SettleNo}}</span>
          <el-input v-else v-model="data.SettleNo" placeholder="请输入费用编码"></el-input>
        </el-form-item>
        <el-form-item label="结算方式名称" prop="SettleName" :class="isMB?'longLabel':''">
          <el-input v-model="data.SettleName" placeholder="请输入结算方式名称" />
        </el-form-item>
        <el-form-item label="默认账号" prop="AccountId">
          <select-input
            placeholder="选择账号"
            :label="data.AccountName"
            v-model="data.AccountId"
            @click="openAccount"
          />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.Sn" v-int style="width: 100px;" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <account-dialog :is-show="false" ref="accountDialog" in-dialog selectable @select="setAccount" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import accountDialog from "@/components/basedata/finance/account/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    accountDialog,
  },
  data() {
    return {
      data: {
        SettleId: 0,
        SettleNo: "",
        SettleName: "",
        AccountId: 0,
        AccountName: "",
        Sn: 0,
        Status: 1,
      },
      api: require("@/api/ba/settle").default,
      code_api: require("@/api/sy/serialCode").default,
      Mode: 0,
      isMB: this.$store.state.isMB,
      rules: {
        SettleNo: [{ required: true, message: "结算方式编码不能为空" }],
        SettleName: [{ required: true, message: "结算方式名称不能为空" }],
        AccountId: [{ required: true, message: "请选择账号" }],
        Sn: [{ required: true, message: "序号不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });

      this.code_api.previewNo('结算方式').then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.SettleNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取结算方式编号失败");
        }
      });
    },
    openAccount() {
      this.$refs.accountDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setAccount(data) {
      console.log("data", data);
      this.data.AccountId = data.AccountId;
      this.data.AccountName = data.AccountName;
    },
  },
};
</script>